module.exports = __webpack_public_path__ + "ac1612e21731e1a027139bd574ecf5e5.woff2";